export const ROUTES = {
  home: '/',
  about: '/hakkimizda',
  services: '/hizmetlerimiz',
  appointment: '/randevu-alin',
  blog: '/goc-notlari',
  faq: '/s-s-s',
  impressum: '/impressum',
  privacy: '/datenschutz',
  withdrawal: '/widerrufsbelehrung',
} as const;

export const SERVICE_ROUTES = {
  migrationPreparation: ROUTES.services,
  education: '/hizmetler-egitim',
  visa: '/hizmetler-vize',
  housing: '/hizmetler-kiralama',
  residence: '/hizmetler-oturum',
  integration: '/hizmetler-entegrasyon',
  postMigration: '/hizmetler-goc-sonrasi',
} as const;

export const primaryNavLinks = [
  { label: 'Hakkımızda', path: ROUTES.about },
  { label: 'Hizmetler', path: ROUTES.services },
  { label: 'Randevu Alın', path: ROUTES.appointment },
  { label: 'Göç Notları', path: ROUTES.blog },
  { label: 'SSS', path: ROUTES.faq },
] as const;

export const footerSiteLinks = [
  { label: 'Hakkımızda', path: ROUTES.about },
  { label: 'Hizmetler', path: ROUTES.services },
  { label: 'Göç Notları', path: ROUTES.blog },
  { label: 'Sıkça Sorulan Sorular', path: ROUTES.faq },
  { label: 'Randevu Alın', path: ROUTES.appointment },
] as const;

export const legalLinks = [
  { label: 'Impressum', path: ROUTES.impressum },
  { label: 'Datenschutzerklärung', path: ROUTES.privacy },
  { label: 'Widerrufsbelehrung', path: ROUTES.withdrawal },
] as const;

export const socialLinks = {
  linkedin: 'https://www.linkedin.com/company/aysegul-sarac-danismanlik/about/?viewAsMember=true',
  instagram: 'https://www.instagram.com/aysegulsaraccom/',
  youtube: 'https://www.youtube.com/@almanyayagoc',
  google: 'https://www.google.com/search?q=Ay%C5%9Feg%C3%BCl+Sara%C3%A7+G%C3%B6%C3%A7+Rehberli%C4%9Fi',
} as const;
